module.exports = __webpack_public_path__ + "static/citadel-0ebcedd773185a2f29be122aba9222ca.png";